import { fetchMemberTimeline, TimeLineLiveType } from '@/api/fetchMemberTimeline'
import { QUERY_KEY } from '@/constants/queryKey'
import { useInfiniteScroller } from '@/hooks/livemallclub/useInfiniteScroller'

type FeedMetaType = {
  roomId: string
  title: string
  coverPhotoUrl: string
  roomDesc: string
  countryCode: string
  ownerName: string
  ownerMemberInfoId: string
  ownerAvatarUrl: string
  startTime: string
  liveTime: string
  liveCloseTime: string
  liveType: 0 | 1 | 2 | 3
  dummyViews: number
  isFavorite: boolean
  isVip: boolean
  valid: boolean
}

export type MemberTimelineLiveFeedType = {
  type: 'live'
  meta: FeedMetaType
}

export type MemberTimelineLiveResponseType = {
  cursorId: string
  feeds: MemberTimelineLiveFeedType[] | null
  hasMore: boolean
}[]

export type LiveType = 'default' | 'vip'

export const useMemberLivesQuery = ({ memberInfoId, type, enabled = true }: { memberInfoId: string; type: TimeLineLiveType; enabled?: boolean }) => {
  const props = useInfiniteScroller<MemberTimelineLiveResponseType>({
    queryKey: [QUERY_KEY.FETCH_MEMBER_TIMELINE_LIVES, { pageSize: 5, type, memberInfoId }],
    queryFunction: ({ pageParam }) =>
      fetchMemberTimeline({
        type,
        pageSize: 5,
        memberInfoId,
        cursorId: pageParam?.cursorId,
      }),
    queryOptions: {
      enabled: !!memberInfoId && !!enabled,
    },
  })

  return {
    ...props,
  }
}
